
import React from 'react';

export const GoogleFormSection: React.FC = () => {
  return (
    <section id="form-section" className="py-24 px-4 bg-slate-950 relative overflow-hidden border-t border-white/5">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px] bg-indigo-600/5 blur-[120px] rounded-full pointer-events-none"></div>
      
      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <span className="text-indigo-400 font-semibold tracking-wider uppercase text-sm">Qualificação</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-4 mb-6">Sua jornada começa aqui</h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Preencha o formulário abaixo para que nosso assistente possa personalizar sua experiência e validar seu acesso à plataforma.
          </p>
        </div>

        <div className="glass rounded-xl overflow-hidden border-white/5 bg-slate-900/40 backdrop-blur-2xl shadow-2xl">
          <iframe 
            src="https://docs.google.com/forms/d/1I69WPdcBC8UodDkyyMD2kgT652x7yM0oCNif-8OKtdg/viewform?embedded=true" 
            width="100%" 
            height="800" 
            frameBorder="0" 
            marginHeight={0} 
            marginWidth={0}
            className="w-full invert-[0.9] hue-rotate-180 contrast-125"
          >
            Carregando…
          </iframe>
        </div>
      </div>
    </section>
  );
};
